import { render, staticRenderFns } from "./tutorInAassessment.vue?vue&type=template&id=a22d4862&scoped=true&"
import script from "./tutorInAassessment.vue?vue&type=script&lang=js&"
export * from "./tutorInAassessment.vue?vue&type=script&lang=js&"
import style0 from "./tutorInAassessment.vue?vue&type=style&index=0&id=a22d4862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22d4862",
  null
  
)

export default component.exports